import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { apiRoute, stateEnum } from "../constants/enum";
const { masterItemEntry } = stateEnum

const initialState = {
    isNewEntry: true,
    detailParams: []
}

const masterItemEntrySlice = createSlice({
    name: masterItemEntry,
    initialState,
    reducers: {
        setNewEntryMode: (state, action) => {
            state.isNewEntry = action.payload;
        },
        resetDetailParams: (state) => {
            state.detailParams = []
            state.isNewEntry = true
        },
        setDetailParams: (state,action) => {
            state.detailParams = action.payload
        },
    },
})

export const{setNewEntryMode,resetDetailParams,setDetailParams}=masterItemEntrySlice.actions
export default masterItemEntrySlice.reducer